import { warn } from "@swivl-mono/helpers";
import { Conversation, UserInterface, UserVarKey, VarDefinitionsType, VarKey } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Vars/Vars/Vars.Controller.ts
export class VarsAPI {
  static async getVarById(orgId: number, userId: number, key: VarKey) {
    return APIService.Server.get<string>(`/vars/org/${orgId}/user/${userId}/var/${key}`);
  }
  static async getVar(userOrConversation: UserInterface | Conversation, key: VarKey) {
    const userId = "userId" in userOrConversation ? userOrConversation.userId : userOrConversation.id;

    return APIService.Server.get<string>(`/vars/org/${userOrConversation.orgId}/user/${userId}/var/${key}`);
  }
  static async getVars<T extends string>(userOrConversation: UserInterface | Conversation, keys: T[]): Promise<{ [K in T]: string | undefined }> {
    const userId = "userId" in userOrConversation ? userOrConversation.userId : userOrConversation.id;

    if (keys.length === 0) {
      warn("No keys found for getVars");
      return {} as any;
    }
    return APIService.Server.get<{ [K in T]: string | undefined }>(`/vars/org/${userOrConversation.orgId}/user/${userId}/vars`, { keys });
  }

  static async getVarsById<T extends string>(orgId: number, userId: number, keys: T[]): Promise<{ [K in T]: string | undefined }> {
    if (keys.length === 0) {
      warn("No keys found for getVars");
      return {} as any;
    }
    return APIService.Server.get<{ [K in T]: string | undefined }>(`/vars/org/${orgId}/user/${userId}/vars`, { keys });
  }

  // static async saveVar(userOrConversation: UserInterface | Conversation, key: VarKey, value: string) {
  //   const userId = 'userId' in userOrConversation ? userOrConversation.userId : userOrConversation.id;
  //   return APIService.Server.put<boolean>(`/vars/org/${userOrConversation.orgId}/user/${userId}/vars`, { [key]: value });
  // }
  // static async saveVars(userOrConversation: UserInterface | Conversation, vars: { [key in VarKey]?: string }, skipPreProcessing: boolean = false) {
  //   const userId = 'userId' in userOrConversation ? userOrConversation.userId : userOrConversation.id;
  //   return APIService.Server.put<{ [key: string]: boolean }>(`/vars/org/${userOrConversation.orgId}/user/${userId}/vars?skipPreProcessing=${skipPreProcessing}`, vars);
  // }

  //NOTE You must ALWAYS update the conversation object in case something under the hood like a merge happened or that the location or brand updated.
  // static async saveVarsAndUpdateConversation(conversation: Conversation,vars: { [key in VarKey]?: string }, skipPreProcessing: boolean = false):Promise<Conversation> {
  //   return APIService.Server.put<Conversation>(`/vars/org/${conversation.orgId}/vars?skipPreProcessing=${skipPreProcessing}`, {conversation,vars});
  // }
  // Taking these out. All Vars need to be saved via the user or conversation
  // static async saveVarById(orgId: number, userId: number, key: string, value: string) {
  //   return  APIService.Server.put<boolean>(`/vars/org/${orgId}/user/${userId}/var/${key}`, value);
  // }
  // static async saveVarsById(orgId: number, userId: number, vars: { [key in VarKey]?: string }) {
  //   return  APIService.Server.put<{ [key: string]: boolean }>(`/vars/org/${orgId}/user/${userId}/vars`, vars);
  // }

  static async saveVarsAndReturnUser(orgId: number, userId: number, vars: { [key in VarKey]?: string }) {
    return APIService.Server.put<{ user?: UserInterface; vars: { [key: string]: boolean } }>(`/vars/org/${orgId}/user/${userId}/vars`, { vars });
  }

  static deleteUserVars(userOrConversation: UserInterface | Conversation, vars: VarKey[]): Promise<boolean> {
    const userId = "userId" in userOrConversation ? userOrConversation.userId : userOrConversation.id;

    return APIService.Server.delete<boolean>(`/vars/org/${userOrConversation.orgId}/user/${userId}/vars`, { vars: vars });
  }

  static async saveEditorData(data: VarDefinitionsType) {
    return APIService.Server.put("/vars/editor", data);
  }
}
